import React  from 'react';
//import logo from '../../data/appData/appImages/entete/logo2.png'
//import logo2 from '/data/appData/appImages/entete/couverture.png'
//import owner_picture from '/data/appData/appImages/owner/owner.jpg'
import './appHeaderCss.css'
import { Link } from 'react-router-dom'
import { BrowserRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

//import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
//import { faMapMarker } from '@fortawesome/fontawesome-free-solid';

function Header(){

    const { i18n } = useTranslation();

    const changeLanguage = (language) => {
        i18n.changeLanguage(language.target.value);
};
    
    return(
        <div>
            <div  className=" bandeauClass bandeauClassResp">

                <div className="logoDiv">
                    <div className="logoDiv1Class logoDiv1ClassResp">
                        <img className='logoImage1'   src={"/data/appData/appImages/entete/couverture.png"} alt='restaurant casa resto' />
                    </div>

                    <div className="logoDiv2Class logoDiv2ClassResp">
                        <div  className="logoImage2Div">
                            <span className='langageDiv' >
                            {/*
                            <button onClick={() => changeLanguage('en')}>English</button>
                            <button onClick={() => changeLanguage('fr')}>Francais</button>
                            */}
                            <select onChange={changeLanguage} >
                                <option value="en" selected >English</option>
                                <option value="fr">Francais</option>
                            </select>
                            </span>
                            <div className='ownerPictureDiv'>
                                <Link to="/page2">  <img className='logoImage2'   src={'/data/appData/appImages/owner/owner.jpg'} alt='casa resto logo' /><br></br>TADLAOUI Said +...</Link>
                            </div>
                            
                        </div>
                        
                    </div>
                </div>

                


                
            </div>
            
           

        </div>



    );
}
export default Header